import { Components, Theme } from '@mui/material/styles';

export const muiIconButtonOverride: Components<Omit<Theme, 'components'>>['MuiIconButton'] = {
  defaultProps: {
    disableRipple: true,
    disableTouchRipple: true,
    disableFocusRipple: true
  }
};
